export default __webpack_public_path__ + "static/media/500.38bdf1cf.jpg";